// src/components/relevant-content/relevant-content.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query RelevantContentQuery($productIdentifier: ProductIdentifierInput!, $context: ContextInput!) {\n    relevantContent(productIdentifier: $productIdentifier, context: $context) {\n      __typename\n      content {\n        ... on ProductAmenitiesSection {\n          elementID\n          title {\n            __typename\n            text\n          }\n          list {\n            __typename\n            ... on EGDSBulletedList {\n              __typename\n              listItems {\n                ... on EGDSTextStandardListItem {\n                  __typename\n                  text\n                }\n              }\n            }\n          }\n        }\n      }\n      impressionAnalytics {\n        __typename\n        referrerId\n        linkName\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
var __Query = gql(_templateObject());
var RelevantContent = function(props) {
    var _list_listItems, _list_listItems1;
    var inputs = props.inputs, skipSsr = props.skipSsr, batchKey = props.batchKey;
    var context = useBexApi().context;
    var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        context: {
            batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
        },
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.relevantContent) {
        return null;
    }
    var _data_relevantContent = data.relevantContent, content = _data_relevantContent.content, impressionAnalytics = _data_relevantContent.impressionAnalytics;
    var title = content.title, list = content.list;
    var relevantAmenity = /* @__PURE__ */ React.createElement(React.Fragment, null, title && /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React.createElement(UitkHeading, {
        tag: "h3",
        size: 6
    }, title === null || title === void 0 ? void 0 : title.text)), (list === null || list === void 0 ? void 0 : list.__typename) === "EGDSBulletedList" && (list === null || list === void 0 ? void 0 : (_list_listItems = list.listItems) === null || _list_listItems === void 0 ? void 0 : _list_listItems.length) && /* @__PURE__ */ React.createElement(UitkList, {
        spacing: false,
        size: 2
    }, list === null || list === void 0 ? void 0 : (_list_listItems1 = list.listItems) === null || _list_listItems1 === void 0 ? void 0 : _list_listItems1.map(function(item, index) {
        return item.__typename === "EGDSTextStandardListItem" && /* @__PURE__ */ React.createElement(UitkListItem, {
            key: "listitems-".concat(index)
        }, item.text);
    })));
    var _impressionAnalytics_linkName;
    return impressionAnalytics ? /* @__PURE__ */ React.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: impressionAnalytics.referrerId,
        linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
    }, relevantAmenity) : relevantAmenity;
};
RelevantContent.displayName = "RelevantContent";
// src/__generated__/globalTypes.ts
var IdentifierType = /* @__PURE__ */ function(IdentifierType2) {
    IdentifierType2["CART_ID"] = "CART_ID";
    IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
    IdentifierType2["OFFER_ID"] = "OFFER_ID";
    IdentifierType2["ORDER_ID"] = "ORDER_ID";
    IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
    return IdentifierType2;
}(IdentifierType || {});
export { IdentifierType, RelevantContent };
//# sourceMappingURL=index.js.map